import React from 'react';
import { get } from 'lodash';
import BlankSlate from 'components/_shared/blank_slate/_blank_slate';

const EditorBlankSlate = props => {
  const customColor = get(document.body, 'dataset.customColor', null);
  return (
    <BlankSlate large>
      <div className="EditorBlankSlate-icon" />
      <div className="EditorBlankSlate-path" />
      <svg
        className="EditorBlankSlate-cloud"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 389 236"
        fill={customColor}
      >
        <path
          d={`M284.7 218.2c-146.43-32.94-150.53 32.6-225.54
            13.9-75-18.7-88.72-86.14 18-126.6 106.74-40.5 181.7-154.26 252-82
            70.3 72.24 101.95 227.62-44.47 194.7z`}
          opacity=".05"
        />
      </svg>
      <div className="NewBlankSlate-description">
        <h2 className="EditorBlankSlate-title">Oops, this lesson is empty!</h2>
        <p>Create a new section to start editing</p>
      </div>
    </BlankSlate>
  );
};

export default EditorBlankSlate;
